import { render, staticRenderFns } from "./ThreeD.vue?vue&type=template&id=1e0be1a8&scoped=true&"
import script from "./ThreeD.vue?vue&type=script&lang=js&"
export * from "./ThreeD.vue?vue&type=script&lang=js&"
import style0 from "./ThreeD.vue?vue&type=style&index=0&id=1e0be1a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0be1a8",
  null
  
)

export default component.exports